import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useNotifications from './useNotifications';
import {
  clearNotifications,
} from './actions';

const Notifications = () => {
  const { error, success, info, autoCloseDuration } = useSelector((state) => state.notifications);

  const dispatch = useDispatch();

  const clearAllNotifications = () => {
    dispatch(clearNotifications());
  };

  const { showError, showInfo, showSuccess } = useNotifications(clearAllNotifications);

  useEffect(() => {
    if (!error) return;
    showError(error);
    // eslint-disable-next-line
  }, [error]);

  useEffect(() => {
    if (!success) return;
    showSuccess(success, autoCloseDuration ?? 3000);
    // eslint-disable-next-line
  }, [success]);

  useEffect(() => {
    if (!info) return;
    showInfo(info);
    // eslint-disable-next-line
  }, [info]);

  return (
    <ToastContainer />
  );
};

export default Notifications;
